/**
 * Component: sa-ecosystem-carousel
 * Description: Ecosystem Carousel using Swiper
 */
if (!customElements.get('sa-ecosystem-carousel')) {
  class SaEcosystemCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSwiper();
      this.initScrollAnimation();
      this.initVideoObserver();
    }

    initVideoObserver() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5 // Play when 50% visible
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const container = entry.target;
          const video = container.querySelector('video');
          if (!video) return;

          const btn = container.querySelector('.sa-ecosystem-carousel__play-btn');

          if (entry.isIntersecting) {
            // Visible -> Play
            video.play().catch(e => {
              // Autoplay might be blocked by browser policy (e.g. low power mode or unmuted)
              // But since we set muted=true in liquid, it should generally work.
            });
            if (btn) btn.style.opacity = '0';
          } else {
            // Hidden -> Pause
            video.pause();
            if (btn) btn.style.opacity = '1';
          }
        });
      }, options);

      // Observe all slide inners (works for both single stage and swiper slides)
      const slides = this.querySelectorAll('.sa-ecosystem-carousel__slide-inner');
      slides.forEach(slide => observer.observe(slide));
    }

    initScrollAnimation() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.classList.add('is-visible');
            observer.disconnect();
          }
        });
      }, { threshold: 0.2 });
      observer.observe(this);
    }

    initSwiper() {
      const swiperContainer = this.querySelector('.sa-ecosystem-carousel__swiper');
      const prevBtn = this.querySelector('.sa-ecosystem-carousel__prev');
      const nextBtn = this.querySelector('.sa-ecosystem-carousel__next');
      const currentCounter = this.querySelector('.sa-ecosystem-carousel__counter-current');

      // Init Play Buttons regardless of Swiper (for single slide mode)
      this.initPlayButtons();

      if (!swiperContainer) return;

      // Get original count from data attribute
      const originalCount = parseInt(this.getAttribute('data-original-count')) || 0;

      this.swiper = new Swiper(swiperContainer, {
        initialSlide: 0,
        slidesPerView: 1.1,
        centeredSlides: true,
        breakpoints: {
          480: {
            slidesPerView: 1.25,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 1.4,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 1.5,
            spaceBetween: 20,
          },
          960: {
            slidesPerView: 1.7,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 1.9,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          1280: {
            slidesPerView: 2.4,
            spaceBetween: 20,
          },
          1440: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          }
        },
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        loopedSlides: 12,
        spaceBetween: 10,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
        on: {
          init: (swiper) => {
            if (currentCounter) {
              let displayIndex = swiper.realIndex + 1;
              if (originalCount > 0) {
                // Adjust index if we manually duplicated slides
                displayIndex = (swiper.realIndex % originalCount) + 1;
              }
              currentCounter.textContent = displayIndex;
            }
            this.handleVideoPlay(swiper.slides[swiper.activeIndex]);
          },
          slideChange: (swiper) => {
            if (currentCounter) {
              let displayIndex = swiper.realIndex + 1;
              if (originalCount > 0) {
                // Adjust index if we manually duplicated slides
                displayIndex = (swiper.realIndex % originalCount) + 1;
              }
              currentCounter.textContent = displayIndex;
            }
            this.pauseAllVideos();
            this.handleVideoPlay(swiper.slides[swiper.activeIndex]);
          }
        }
      });
      
      console.log('this.swiper', this.swiper);
      
      this.initPlayButtons();
    }

    initPlayButtons() {
      const playBtns = this.querySelectorAll('.sa-ecosystem-carousel__play-btn');
      playBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation(); // Prevent swiper slide click if necessary
          const slide = btn.closest('.sa-ecosystem-carousel__slide-inner');
          if (!slide) return;
          
          // Logic for Swiper mode: Check if slide is active (optional, depending on requirement)
          // In single mode, we don't have swiper-slide-active class, so we just play.
          
          const swiperSlide = btn.closest('.swiper-slide');
          
          if (this.swiper && swiperSlide && !swiperSlide.classList.contains('swiper-slide-active')) {
             // If in swiper mode and clicking on a non-active slide, slide to it
             this.swiper.slideTo(this.swiper.slides.indexOf(swiperSlide));
             return;
          }

          const video = slide.querySelector('video');
          if (video) {
            if (video.paused) {
              video.play();
              btn.style.opacity = '0'; // Hide play button when playing
            } else {
              video.pause();
              btn.style.opacity = '1';
            }
          }
        });
      });
    }

    pauseAllVideos() {
      const videos = this.querySelectorAll('video');
      videos.forEach(video => {
        video.pause();
        video.currentTime = 0;
        const btn = video.parentElement.querySelector('.sa-ecosystem-carousel__play-btn');
        if (btn) btn.style.opacity = '1';
      });
    }

    handleVideoPlay(slide) {
      // Logic handled by IntersectionObserver (initVideoObserver)
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy();
      }
    }
  }

  customElements.define('sa-ecosystem-carousel', SaEcosystemCarousel);
}